var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 6,
    viewBox: "0 0 20 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "more",
    d: "M20 3C20 3.6875 19.7552 4.27604 19.2656 4.76562C18.776 5.25521 18.1875 5.5 17.5 5.5C16.8125 5.5 16.224 5.25521 15.7344 4.76562C15.2448 4.27604 15 3.6875 15 3C15 2.3125 15.2448 1.72396 15.7344 1.23437C16.224 0.74479 16.8125 0.499999 17.5 0.499999C18.1875 0.499999 18.776 0.74479 19.2656 1.23437C19.7552 1.72396 20 2.3125 20 3ZM12.5 3C12.5 3.6875 12.2552 4.27604 11.7656 4.76562C11.276 5.25521 10.6875 5.5 10 5.5C9.3125 5.5 8.72396 5.25521 8.23438 4.76562C7.74479 4.27604 7.5 3.6875 7.5 3C7.5 2.3125 7.74479 1.72396 8.23438 1.23437C8.72396 0.744791 9.3125 0.499999 10 0.499999C10.6875 0.499999 11.276 0.744791 11.7656 1.23437C12.2552 1.72396 12.5 2.3125 12.5 3ZM5 3C5 3.6875 4.75521 4.27604 4.26563 4.76562C3.77604 5.25521 3.1875 5.5 2.5 5.5C1.8125 5.5 1.22396 5.25521 0.734375 4.76562C0.244792 4.27604 -7.92269e-08 3.6875 -1.09278e-07 3C-1.3933e-07 2.3125 0.244792 1.72396 0.734375 1.23437C1.22396 0.744791 1.8125 0.499999 2.5 0.499999C3.1875 0.499999 3.77604 0.744791 4.26563 1.23437C4.75521 1.72396 5 2.3125 5 3Z",
    fill: "#000A18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d45ba387890dce27e82c2c6ab5425d8f.svg";
export { ForwardRef as ReactComponent };